import { Data, Effect } from "effect"

const mimeToExtension = {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
    "image/webp": "webp",
    "image/svg+xml": "svg",
    // "application/pdf": "pdf",
    // "text/plain": "txt",
    // "text/html": "html",
    // "text/css": "css",
    // "text/javascript": "js",
    // "application/json": "json",
    // "application/xml": "xml",
    // "video/mp4": "mp4",
    // "audio/mpeg": "mp3",
    // "audio/wav": "wav",
    // Add more mappings as needed
} as const

/**
 * Get the file extension for a given blob type.
 * @param blob - The blob to get the extension for.
 * @returns The file extension for the blob type.
 */
export const BlobToExtension = Effect.fn("BlobToExtension")(function* (blob: Blob) {
    const type = blob.type
    if (type in mimeToExtension) {
        return mimeToExtension[type as keyof typeof mimeToExtension]
    }
    return yield* Effect.fail(
        new UnrecognizedBlobExtension({ message: `Unrecognized blob type: ${type}` }),
    )
})

export class UnrecognizedBlobExtension extends Data.TaggedError("UnrecognizedBlobExtension")<{
    message: string
}> {}
